import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="state">
      <div style={{ fontSize: 48 }}>🧴</div>
      <div className="state__title">페이지를 찾을 수 없습니다</div>
      <p>주소가 바뀌었거나 삭제된 페이지입니다.</p>
      <Link to="/" className="btn btn--primary btn--sm">
        홈으로 가기
      </Link>
    </div>
  );
}
